/*
 * Discount banner — keeps the PDP banner pill in sync with the selected variant.
 * Reads pre-computed per-variant discount % from the banner's data-variant-discounts
 * attribute (set by snippets/discount-banner.liquid). No DOM scanning, no fetch,
 * no dependency on inline product JSON having compare_at_price.
 */
(function () {
  function getBanner() {
    return document.querySelector('#Product-Slider [data-discount-banner]');
  }

  function getDiscountMap(banner) {
    if (!banner) return {};
    var raw = banner.getAttribute('data-variant-discounts');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }

  function getCurrentVariantId() {
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return null;
  }

  var lastAppliedId = null;

  function updatePill(variantId) {
    if (!variantId) return;
    if (String(variantId) === String(lastAppliedId)) return;
    var banner = getBanner();
    var pill = banner && banner.querySelector('[data-discount-pill]');
    if (!pill) return;
    var map = getDiscountMap(banner);
    var pct = Number(map[String(variantId)] || 0);
    if (pct > 0) {
      pill.textContent = pct + '% off';
      banner.classList.remove('is-hidden');
    } else {
      banner.classList.add('is-hidden');
    }
    lastAppliedId = variantId;
  }

  function init() {
    if (!getBanner()) return;

    // Strategy 1: theme custom events
    ['variant:change', 'variantChange', 'variant-change'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var id = e.detail && (
          (e.detail.variant && e.detail.variant.id)
          || e.detail.id
          || (e.detail.selected_variant && e.detail.selected_variant.id)
        );
        if (id) updatePill(id);
      });
    });

    // Strategy 2: change events anywhere in the add-to-cart form
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches && t.matches('[name="id"]')) {
        updatePill(t.value);
        return;
      }
      var form = t.closest && t.closest('form[action*="/cart/add"]');
      if (form) {
        setTimeout(function () { updatePill(getCurrentVariantId()); }, 50);
      }
    });

    // Strategy 3: MutationObserver on the hidden id input value
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput) {
      try {
        new MutationObserver(function () { updatePill(idInput.value); })
          .observe(idInput, { attributes: true, attributeFilter: ['value'] });
      } catch (e) {}
    }

    // Strategy 4: history API hooks (themes that update ?variant= without reload)
    function onUrlChange() { updatePill(getCurrentVariantId()); }
    window.addEventListener('popstate', onUrlChange);
    ['pushState', 'replaceState'].forEach(function (m) {
      var orig = history[m];
      history[m] = function () {
        var r = orig.apply(this, arguments);
        setTimeout(onUrlChange, 0);
        return r;
      };
    });

    // Strategy 5: 250ms polling fallback — guaranteed to catch any change
    setInterval(function () { updatePill(getCurrentVariantId()); }, 250);

    // Initial sync
    var initial = getCurrentVariantId();
    if (initial) updatePill(initial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
